import { DateField } from "@/components/DateField";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { moisLabel } from "@/lib/api";

export const PERSO = "perso";

export const bornesMois = (m) => {
  const [y, mm] = m.split("-").map(Number);
  return { debut: `${m}-01`, fin: `${m}-${String(new Date(y, mm, 0).getDate()).padStart(2, "0")}` };
};

// value : { mode: "AAAA-MM" | "all" | "perso", debut, fin }
export const periodeParams = (p) => {
  if (!p || p.mode === "all") return {};
  if (p.mode === PERSO) return p.debut && p.fin ? { debut: p.debut, fin: p.fin } : {};
  return bornesMois(p.mode);
};

export const PeriodPicker = ({ value, onChange, mois, sansTout = false }) => (
  <div className="flex flex-col sm:flex-row gap-2" data-testid="period-picker">
    <Select value={value.mode} onValueChange={(mode) => onChange({ ...value, mode })}>
      <SelectTrigger className="h-9 w-full sm:w-48 bg-white" data-testid="period-mode-select"><SelectValue /></SelectTrigger>
      <SelectContent>
        {mois.map((m) => <SelectItem key={m} value={m} data-testid={`period-mois-${m}`}>Mois : {moisLabel(m)}</SelectItem>)}
        <SelectItem value={PERSO} data-testid="period-perso">Dates personnalisées</SelectItem>
        {!sansTout && <SelectItem value="all" data-testid="period-all">Toute la période</SelectItem>}
      </SelectContent>
    </Select>
    {value.mode === PERSO && (
      <div className="flex items-center gap-1.5 text-xs text-slate-600">
        du <DateField value={value.debut || ""} onChange={(v) => onChange({ ...value, debut: v })} onPeriode={(p) => onChange({ ...value, ...p })} className="w-40 bg-white" data-testid="period-debut-input" />
        au <DateField value={value.fin || ""} onChange={(v) => onChange({ ...value, fin: v })} onPeriode={(p) => onChange({ ...value, ...p })} className="w-40 bg-white" data-testid="period-fin-input" />
      </div>
    )}
  </div>
);
